import { SERVER_API } from "../../Constant";
import axios from "axios";

export const FetchVehicleType_api = async () => {
  try {
    const response = await axios.get(
      `${SERVER_API}/Payments/fetch_vehicle_type_data.php`,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (error: any) {
    console.error("Fetch vehicle type failed:", error);
    return { error: "Fetch vehicle type failed" };
  }
};
